import { WidgetType } from 'widgets/WidgetType';
import { useContext } from 'react';
import AppContext from 'app/AppContext';
import { useDebouncedFunction } from '@instinet-analytics/core-lib';

export const useClickstreamRecordWidgetUsage = (widget: WidgetType) => {
    const {
        services: { clickstreamService },
    } = useContext(AppContext);

    return useDebouncedFunction(
        () => {
            clickstreamService.recordWidgetUsage(widget);
        },
        500,
        { callOnUnmount: true }
    )[0];
};

export const useClickstreamRecordWidgetFeatureUsage = (
    widget: WidgetType,
    feature: string
) => {
    const {
        services: { clickstreamService },
    } = useContext(AppContext);

    return useDebouncedFunction(
        () => {
            clickstreamService.recordWidgetFeatureUsage(widget, feature);
        },
        500,
        { callOnUnmount: true }
    )[0];
};
